import { Injectable } from '@angular/core';
import { CoolLocalStorage } from '@angular-cool/storage';
import { bcSessionKeys } from 'common/common/constants/session-keys';
import { bcEnums } from 'common/common/constants/boldchat-enums';

@Injectable()
export class AccessibilityFontSizeSetterService {

  private _fontSizePercentage: number;
  private _isFontSizeAccessibilitySettingTurnedOn: boolean;
  private readonly ORIGINAL_FONT_SIZE_PERCENTAGE = 100;

  constructor(private _localStorage: CoolLocalStorage) {
  }

  get isFontSizeAccessibilitySettingTurnedOn(): boolean {
    this._getStoredAccessibilitySetting();
    return this._isFontSizeAccessibilitySettingTurnedOn;
  }

  get fontSizePercentage(): number {
    return this._fontSizePercentage;
  }

  public saveFontSizeToStorage(fontSizePercentage: number): void {
    this._localStorage.setItem(bcSessionKeys.storage.fontSizePercentage, fontSizePercentage.toString());
    this._fontSizePercentage = fontSizePercentage;
  }

  public getFontSizeFromStorage() {
    return this._localStorage.getItem(bcSessionKeys.storage.fontSizePercentage);
  }

  public setFontSize(): void {
    const storedFontSizeValue = this.getFontSizeFromStorage();
    if (storedFontSizeValue) {
      this._fontSizePercentage = parseInt(storedFontSizeValue, 10);
    } else {
      this._fontSizePercentage = this.ORIGINAL_FONT_SIZE_PERCENTAGE;
      this.saveFontSizeToStorage(this._fontSizePercentage);
    }
  }

  private _getStoredAccessibilitySetting(): void {
    const storedAccessibilitySettings = this._localStorage.tryGetObject(bcSessionKeys.storage.accessibilitySettings);
    if (storedAccessibilitySettings) {
      Object.keys(storedAccessibilitySettings).forEach((key) => {
        if (storedAccessibilitySettings[key].name === bcEnums.accessibilitySettingNames.CONVERSATION_FONT_SIZE) {
          this._isFontSizeAccessibilitySettingTurnedOn = storedAccessibilitySettings[key].isTurnedOn;
        }
      });
    }
  }
}
